import { TextCell } from '@common/components/TextCell';

interface DmvWorkflowCellProps {
	dmvWorkflow?: string;
}

export const DmvWorkflowCell = ({ dmvWorkflow }: DmvWorkflowCellProps) => {
	return <TextCell value={dmvWorkflow} />;
};
